import { Injectable } from '@angular/core';
@Injectable()
export class VoucherBase {
  constructor() { }
  voucher_guid: any;
  voucher_mod_guid: any;
  voucher_name: string;
  voucher_type: string;
  voucher_min_order_amount:number;
  voucher_amount: number;
  voucher_max_percentage_amount:number;
  voucher_percentage:number;
  voucher_value_type:string;
}
